import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

interface Props {
  newVersion?: boolean
  onConfirm: () => void
  onClose: () => void
}

const EffectiveAtDisclaimerModal = ({ newVersion = false, onConfirm, onClose }: Props) => {
  const description = (): string =>
    newVersion
      ? i18n.t(
          'time_tracking.settings.versions.effective_at_disclaimer_modal.new_version_description'
        )
      : i18n.t(
          'time_tracking.settings.versions.effective_at_disclaimer_modal.overwrite_version_description'
        )

  return (
    <Modal
      illustration="alert"
      title={i18n.t('time_tracking.settings.versions.effective_at_disclaimer_modal.title')}
      description={description()}
      onSubmit={onConfirm}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button submit>
            {i18n.t('time_tracking.settings.versions.effective_at_disclaimer_modal.confirm')}
          </Button>
        </>
      }
    />
  )
}

export default observer(EffectiveAtDisclaimerModal)
